import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["dialog", "overlay"];
  static values = {
    id: String,
    open: { type: Boolean, default: false },
  };

  declare readonly dialogTarget: HTMLElement;
  declare readonly overlayTarget: HTMLElement;
  declare idValue: string;
  declare openValue: boolean;

  private showDialog = (e: Event): void => {
    const customEvent = e as CustomEvent<{ dialogId: string }>;
    if (customEvent.detail.dialogId === this.idValue) this.show();
  };

  connect() {
    addEventListener("show-dialog", this.showDialog);
  }

  disconnect() {
    removeEventListener("show-dialog", this.showDialog);
  }

  openValueChanged() {
    if (this.openValue === true) {
      this.dialogTarget.removeAttribute("hidden");
      this.overlayTarget.removeAttribute("hidden");
    } else {
      this.dialogTarget.setAttribute("hidden", "true");
      this.overlayTarget.setAttribute("hidden", "true");
    }
  }

  show() {
    this.openValue = true;
  }

  close() {
    this.openValue = false;
  }
}
